import GiftOccasion from './components/GiftsPage/GiftOccasionComponent';
export default GiftOccasion